import { DefaultRoomGuard } from "./default-room/default-room.guard";
import { AuthorizeGuard } from "./authorize/authorize.guard";
import { RoomInvitationFirstGuard } from "./room-invitation-first.guard";

export { DefaultRoomGuard, AuthorizeGuard, RoomInvitationFirstGuard };

export default [DefaultRoomGuard, AuthorizeGuard, RoomInvitationFirstGuard];
